import SolarSystem from '../components/SolarSystem';
import Timeline from '../components/Timeline';
import LayerPanel from '../components/LayerPanel';
import DetailPanel from '../components/DetailPanel';
import ScenariosPanel from '../components/ScenariosPanel';

export default function Planetarium() {
  return (
    <>
      <Timeline />
      <div className="canvas-wrap">
        <SolarSystem />
        <ScenariosPanel />
        <LayerPanel />
        <DetailPanel />
      </div>
    </>
  );
}
